import { Container, ContainerGutter, ContainerPadding, Text, TextAlignment, TokenTextAppearance, TextTag } from '@volkswagen-onehub/components-core';
import React from 'react';

interface AdditionalOptionWrapperInterface {
    label : string
}

const AdditionalOptionWrapper = ({ label, children } : React.PropsWithChildren<AdditionalOptionWrapperInterface>) => {

    return (
        <Container
            wrap="always"
            stretchContent
            gutter={ContainerGutter.static100}>
                <Container stretchContent>
                    <Text tag={TextTag.p} bold appearance={TokenTextAppearance.copy200}
                        textAlign={TextAlignment.start}>{label}</Text>
                </Container>

                <Container
                    gutter={ContainerGutter.static150}
                    stretchContent
                    padding={{ left: ContainerPadding.static250 }}
                    wrap="always">

                    { children }
                </Container>
        </Container>
    );
}

export default AdditionalOptionWrapper;
